export default __webpack_public_path__ + "static/media/MicrosoftTeams-image-(7)-375X550.20c1dc7b.png";